import React, { Component } from 'react';
import Device from '../../devices/device';
import PropTypes from 'prop-types';
import './_styles.scss';
import { Button } from '../../packages/components';
import Asset from '../../requests/apa/Asset';

export class YellowButton extends Component {

     constructor(props) {
        super(props);
        this.keys = Device.getDevice().getKeys();
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

        if (currentKey === 'YELLOW') {
            e.preventDefault();
            e.stopPropagation();
            this.props.onClick(e);
        }
    }

    render() {
        const { label, onClick } = this.props;

        return (
            <Button className='back-button focusable' onClick={onClick}>
                <p>
                    <span className="yellow-indicator"/>
                    <img className="back-icon" src={Asset.get('top_head_option_back')}/>
                    <span className='back-button-title'>{label}</span>
                </p>
            </Button>
        );
    }
}

YellowButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/YellowButton/YellowButton.jsx